<template>
  <div class="mt-4">
    <div id="mm_click_pie_charts"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MMClicksPieChart",
  data: () => {
    return {};
  },
  props: {},
  components: {},
  computed: {
    ...mapState(["campaign"])
  },
  mounted() {
    var options_mm_pie = {
      series: [
        this.$store.state.campaign.campaign_report.CampaignHeader
          .MultiMediaAggregates.SM_Clicks,
        this.$store.state.campaign.campaign_report.CampaignHeader
          .MultiMediaAggregates.TDA_Clicks
      ],
      chart: {
        type: "pie",
        height: 250
      },
      dataLabels: {
        enabled: true
        // formatter: function(val) {

        //   return val; // Simply return the raw value
        // }
      },
      labels: ["Social Media Clicks", "Targeted Ad Clicks"],
      title: {
        text: "Clicks",
        align: "left"
      },
      legend: {
        position: "bottom",
        fontSize: "16px",
        fontWeight: 500
      },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -20
          }
        }
      },
      colors: ["#e23e25DE", "#36454fDE", "#F0DC36DE", "#ADADADDE"]
    };

    var mm_click_pie = new ApexCharts(
      document.querySelector("#mm_click_pie_charts"),
      options_mm_pie
    );

    mm_click_pie.render();
  }
};
</script>

<style lang="scss" scoped></style>
